import { render, staticRenderFns } from "./StreamController.vue?vue&type=template&id=1c2c8bea&scoped=true&"
import script from "./StreamController.vue?vue&type=script&lang=ts&"
export * from "./StreamController.vue?vue&type=script&lang=ts&"
import style0 from "./StreamController.vue?vue&type=style&index=0&id=1c2c8bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c8bea",
  null
  
)

export default component.exports